import React from 'react';
import styled from 'styled-components';
import { Responsive, Grid } from 'semantic-ui-react';

const Container = styled.div`
  background-color: #e4ff5f;
  padding: 0 10px 40px 10px;
`;

const LargeGifContainer = styled.div`
  overflow: hidden;
  border-radius: 16px;
  width: 241px;
  height: 485px;
`;

const GifContainer = styled.div`
  overflow: hidden;
  border-radius: 16px;
  width: 180px;
  height: 362px;
`;

const MobileGifContainer = styled.div`
  overflow: hidden;
  border-radius: 16px;
  width: 40vw;
  height: 40vw;
`;

const LargeGif = ({ image }: { image: string }) => {
  return (
    <LargeGifContainer>
      <img width="100%" alt="gif" src={require(`../assets/gifs/${image}`)} />
    </LargeGifContainer>
  );
};

const Gif = ({ image }: { image: string }) => {
  return (
    <GifContainer>
      <img width="100%" alt="gif" src={require(`../assets/gifs/${image}`)} />
    </GifContainer>
  );
};

const MobileGif = ({ image }: { image: string }) => {
  return (
    <MobileGifContainer>
      <img width="100%" alt="gif" src={require(`../assets/gifs/${image}`)} />
    </MobileGifContainer>
  );
};

const DATA = [
  {
    image: 'header1.gif'
  },
  {
    image: 'header2.gif'
  },
  {
    image: 'header3.gif'
  },
  {
    image: 'header4.gif'
  },
  {
    image: 'header5.gif'
  }
];

export default () => {
  return (
    <Container>
      <div className="container-box">
        <Responsive minWidth={920}>
          <Grid>
            <Grid.Row columns="3">
              <Grid.Column>
                <LargeGif image={DATA[3].image} />
              </Grid.Column>
              <Grid.Column>
                <LargeGif image={DATA[1].image} />
              </Grid.Column>
              <Grid.Column>
                <LargeGif image={DATA[0].image} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Responsive>
        <Responsive minWidth={640} maxWidth={919}>
          <Grid>
            <Grid.Row columns="3">
              <Grid.Column>
                <Gif image={DATA[3].image} />
              </Grid.Column>
              <Grid.Column>
                <Gif image={DATA[1].image} />
              </Grid.Column>
              <Grid.Column>
                <Gif image={DATA[0].image} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Responsive>
        <Responsive maxWidth={639}>
          <Grid>
            <Grid.Row columns="2">
              <Grid.Column>
                <MobileGif image={DATA[0].image} />
              </Grid.Column>
              <Grid.Column>
                <MobileGif image={DATA[1].image} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="2">
              <Grid.Column>
                <MobileGif image={DATA[2].image} />
              </Grid.Column>
              <Grid.Column>
                <MobileGif image={DATA[3].image} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Responsive>
      </div>
    </Container>
  );
};
